<template>
  <span>
    {{ dobDisplay }}
    <v-tooltip v-if="birthdayIcon" bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-icon small v-bind="attrs" v-on="on" :color="birthdayIconColor">{{ birthdayIcon }}</v-icon>
      </template>
      <span>{{ birthdayTooltip }}</span>
    </v-tooltip>
  </span>
</template>

<script>
var moment = require("moment");

export default {
  props: ["dob"],
  data() {
    return {
      dobDisplay: null,
      daysUntilBirthday: 9999,
    };
  },
  computed: {
    birthdayIcon() {
      if (this.daysUntilBirthday === 9999) return null;
      return this.daysUntilBirthday === 0 ? "mdi-cake-variant" : "mdi-help-circle-outline";
    },
    birthdayIconColor() {
      return this.daysUntilBirthday === 0 ? "pink" : undefined;
    },
    birthdayTooltip() {
      if (this.daysUntilBirthday === 9999) return "";
      if (this.daysUntilBirthday === 0) return "Birthday today!";
      if (this.daysUntilBirthday < 0)
        return `Birthday in ${Math.abs(this.daysUntilBirthday)} day(s)`;
      return `Birthday was ${this.daysUntilBirthday} day(s) ago`;
    },
  },
  watch: {
    dob: {
      immediate: true,
      handler: function (newValue) {
        this.updateDob(newValue);
      },
    },
  },
  methods: {
    updateDob() {
      if (this.dob) {
        const datePart = this.dob.toString().split("T")[0];
        const parts = datePart.split("-");
        let date = new Date(parts[0], parts[1] - 1, parts[2]);
        let age = date ? "(" + moment().diff(date, "years") + ")" : "";
        let bday = this.$d(date, "month_day_year", this.$i18n.locale);
        this.dobDisplay = bday + " " + age;

        let today = new Date();
        today.setHours(0, 0, 0, 0);
        let bdayThisYear = new Date(today.getFullYear(), date.getMonth(), date.getDate());
        let differenceInTime = bdayThisYear.getTime() - today.getTime();
        this.daysUntilBirthday = -1 * Math.round(differenceInTime / (1000 * 3600 * 24));
      }
      return "";
    },
  },
};
</script>
